/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemTypeWithRelations } from '../../models/item-type-with-relations';

export interface GetItemTypesList$Params {
}

export function getItemTypesList(http: HttpClient, rootUrl: string, params?: GetItemTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getItemTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemTypeWithRelations>>;
    })
  );
}

getItemTypesList.PATH = '/item-types';
